import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useForm } from 'react-hook-form';
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { Fetch } from "../../shared/Fetch";
import { IBranchMastDropdown, ICityMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, IStateMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { useEffect, useState } from "react";
import { JVDropdown } from "../../shared/JVDropdown";

export interface IFilterContactPerson {
    fromDate?: Date | null,
    toDate?: Date | null,
    company?: IClientCompanyDropdown,
    city?: ICityMastDropdown,
    state?: IStateMastDropdown,
    company_ID?: number,
    city_ID?: number,
    state_ID?: number,
    email?: string | null,
    majorSkill?: string | null,
    salesPerson_Company_ID?: number | null,
    salesPerson_Branch_ID?: number | null,
    sales_Person_Id?: number | null,
}
export const EmptyFilter: IFilterContactPerson = {
    fromDate: null,
    toDate: null,
    company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    city: { city_ID: 0, city_Name: "" },
    state: { state_ID: 0, state_Name: "" },
    company_ID: undefined,
    city_ID: undefined,
    state_ID: undefined,
    email: "",
    majorSkill: "",
    salesPerson_Company_ID: null,
    salesPerson_Branch_ID: null,
    sales_Person_Id: null,
}
interface Iprops {
    filters: IFilterContactPerson,
    setFilters: (filters: IFilterContactPerson) => void,
}

export const Filter = (props: Iprops) => {
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [shwCities, setShwCities] = useState(0);
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const toast = useRef<any>(null);

    const { control, handleSubmit, reset, watch } = useForm<IFilterContactPerson>({
        defaultValues: props.filters,
        shouldFocusError: false
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "salesPerson_Company_ID") {
                if (value.salesPerson_Company_ID != 0 && value.salesPerson_Company_ID != null) {
                    loadBranches(value.salesPerson_Company_ID);
                    loadSm(0, value.salesPerson_Company_ID);
                } else {
                    loadBranches();
                }
            }

            if (name === "salesPerson_Branch_ID") {
                if (value.salesPerson_Branch_ID != 0 && value.salesPerson_Branch_ID != null) {
                    loadSm(value.salesPerson_Branch_ID, 0);
                } else {
                    if (control._formValues.company != 0 && control._formValues.company != null) {
                        loadSm(0, value.salesPerson_Company_ID);
                    } else if (control._formValues.company == 0) {
                        loadSm(0, 0);
                    }
                }
            }

            if (name === "state") {
                if (value.state?.state_ID != 0 && value.state?.state_ID != null) {
                    setShwCities(value.state?.state_ID);
                }
            }

            if (name === "city") {
                if (control._formValues.state?.state_ID == 0 || control._formValues.state?.state_ID != null) {
                    toast.current.show({ severity: 'error', detail: 'Select the State First.' });
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadCities = async (filter: string | null) => {
        let query = `filter=${filter}` + (shwCities != 0 ? `&state_id=${shwCities}` : "");
        const response = await Fetch("Dropdown/cities", "GET", null, query, null);
        if (response) {
            const data: Array<ICityMastDropdown> = await response.json();
            setCities(data);
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSales(data);
        }
    }

    const searchToDB = async (body: IFilterContactPerson) => {
        props.setFilters(body);
    }

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            }
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }

    useEffect(() => {
        loadCompanies();
        loadBranches();
    }, []);

    function onSubmit(data: IFilterContactPerson) {
        data.company_ID = data.company?.vendor_Company_ID;
        data.state_ID = data.state?.state_ID;
        data.city_ID = data.city?.city_ID;
        // console.log(data);
        searchToDB(data);
    }
    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Clients" modal className="p-fluid" onHide={onHide}>
        <>

            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdownInput column={6} completeMethod={completeMethodClientCompanies} label="Company Name" control={control} name="company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />
                <JVDropdown column={6} label="Company" control={control} name="salesPerson_Company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
                <JVDropdown column={6} label="Branch" control={control} name="salesPerson_Branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter); loadCompanies(); loadBranches(0); }} type="button"></Button>
                </div>
            </form>
            <Toast ref={toast} />
        </>
    );
}